/*************************************
 *
 * 用户协议路由管理
 *
 *************************************/

const center = [
  {
    path: '/center/privacy',
    name: 'CenterPrivacy',
    component: () => import('@/views/center/privacy'),
    meta: {
      title: '隐私条款',
      keepAlive: false,
      auth: true,
      isWechat: false
    }
  },
  {
    path: '/center/registration',
    name: 'CenterRegistration',
    component: () => import('@/views/center/registration'),
    meta: {
      title: '注册协议',
      keepAlive: false,
      auth: true,
      isWechat: false
    }
  }
]

export default center



// WEBPACK FOOTER //
// ./src/router/modules/center.js